import React from 'react'

import { notification } from 'antd'
import { consts } from "@config";
import { validateCPF, validateCNPJ } from "@parts"

const clients = JSON.parse(window.localStorage.getItem(consts.CLIENTS))


export default function genericValidator(props, step = null, idClient = "") {
    const {
        name, phone_number, email, doc, type,
        fancyName, cnae,
        cityLocation, district, postalCode, stateLocation, street
    } = props;

    let errors = [];

    if (step === null || step.length === 0) {
        if (name === "") {
            errors.push("Nome Inválido")
        }

        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))) {
            errors.push("Email Inválido")
        } else {
            for (let i = 0; i < clients.length; i++) {
                const client = clients[i]
                if (!(idClient === client.id) && client.email === email) {
                    errors.push("Email já cadastrado")
                }
            }
        }

        if (phone_number.length !== 11) {
            errors.push("Telefone Inválido")
        }
        if (type == 0 && !validateCPF(doc)) {
            errors.push("CPF Inválido")
        } else if (type > 0 && !validateCNPJ(doc)) {
            errors.push("CNPJ Inválido")
        }
    }

    if ((step === null || step === 1) && type) {
        if (!fancyName.length) errors.push("Nome Fantasia Inválido")
        if (!cnae.code) errors.push("Cnae Inválido")  
    }
    if (step === null || (step === 2 || (!type && step === 1))) {
        if (postalCode.length != 8) errors.push("CEP Inválido")
        if (!stateLocation.length) errors.push("Estado Inválido")
        if (!cityLocation.length) errors.push("Cidade Inválida")
        if (!district.length) errors.push("Bairro Inválido")
        if (!street.length) errors.push("Rua Inválida")
    }

    if (errors.length) { 
        notification.open({
            type: 'error',
            message: "Campos Obrigatórios (Verifique se estão corretos) ",
            description: <ul>{errors.map(err => <li>{err}</li>)}</ul>,
            key: 4,
            duration: 5
        })
        return false
    }

    return true
}



// WEBPACK FOOTER //
// ./src/components/parts/utils/genericValidator.jsx